import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getLandscapingData(context) {
      const response = await Vue.axios.get(`${URL_API}landscaping`);
      let data = response["data"];
      context.commit("updateLandscapingData", data);
    },
    async createLandscapingData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}landscaping/store`, body, config);
      context.dispatch("getLandscapingData");
    },
    async pushLandscapingData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}landscaping/update`, body, config);
      context.dispatch("getLandscapingData");
    },
    async destroyLandscapingData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}landscaping/destroy`, body, config);
      context.dispatch("getLandscapingData");
    }
  },
  mutations: {
    updateLandscapingData(state, landscapingData) {
      state.landscapingData = landscapingData;
    }
  },
  state: {
    landscapingData: []
  },
  getters: {
    allLandscapingData(state) {
      return state.landscapingData;
    }
  }
};